// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@-webkit-keyframes leaflet-gestures-fadein {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes leaflet-gestures-fadein {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

.leaflet-container:after {
  -webkit-animation: leaflet-gestures-fadein 0.8s backwards;
          animation: leaflet-gestures-fadein 0.8s backwards;
  color: #fff;
  font-family: "Roboto", Arial, sans-serif;
  font-size: 22px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 15px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 461;
  pointer-events: none; }

.leaflet-gesture-handling-touch-warning:after,
.leaflet-gesture-handling-scroll-warning:after {
  -webkit-animation: leaflet-gestures-fadein 0.8s forwards;
          animation: leaflet-gestures-fadein 0.8s forwards; }

.leaflet-gesture-handling-touch-warning:after {
  content: attr(data-gesture-handling-touch-content); }

.leaflet-gesture-handling-scroll-warning:after {
  content: attr(data-gesture-handling-scroll-content); }
`, "",{"version":3,"sources":["webpack://./node_modules/leaflet-gesture-handling/dist/leaflet-gesture-handling.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,yDAAyD;UACjD,iDAAiD;EACzD,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB,EAAE;;AAExB;;EAEE,wDAAwD;UAChD,gDAAgD,EAAE;;AAE5D;EACE,kDAAkD,EAAE;;AAEtD;EACE,mDAAmD,EAAE","sourcesContent":["@-webkit-keyframes leaflet-gestures-fadein {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes leaflet-gestures-fadein {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.leaflet-container:after {\n  -webkit-animation: leaflet-gestures-fadein 0.8s backwards;\n          animation: leaflet-gestures-fadein 0.8s backwards;\n  color: #fff;\n  font-family: \"Roboto\", Arial, sans-serif;\n  font-size: 22px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 15px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 461;\n  pointer-events: none; }\n\n.leaflet-gesture-handling-touch-warning:after,\n.leaflet-gesture-handling-scroll-warning:after {\n  -webkit-animation: leaflet-gestures-fadein 0.8s forwards;\n          animation: leaflet-gestures-fadein 0.8s forwards; }\n\n.leaflet-gesture-handling-touch-warning:after {\n  content: attr(data-gesture-handling-touch-content); }\n\n.leaflet-gesture-handling-scroll-warning:after {\n  content: attr(data-gesture-handling-scroll-content); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
